<template>
  <div class="brutto text-dark" :class="{'brutto--kindergarten': isKindergarten}">
    <button class="do-bttn" @click="setIsNormModal">Normberegning</button>
    <DModal v-if="isActive" :isBgOverlay="true" :showClose="false" :placeInTop="true">
      <div class="brutto-container brutto-container-denmark" slot="insertComponent">
        <div class="brutto-container__header">
          <h2>Normberegning</h2>
          <div class="icon__bg-circle doc-modal__close" @click="close">
            <span class="icon-cross2"></span>
          </div>
        </div>
        <div class="brutto-container__body">
          <div class="brutto-container__body__left">
            <div class="d-tabs__header">
              <div class="d-tabs" v-show="isEditWorkHours">
                <div class="d-tabs__tab" @click="setActiveTab(0)" :class="{'d-tabs__tab--active': getIsActiveTab(0)}">
                  Bruttotid
                </div>
                <div class="d-tabs__tab" @click="setActiveTab(1)" :class="{'d-tabs__tab--active': getIsActiveTab(1)}">
                  Nettotid
                </div>
              </div>
              <div class="d-tabs__header__right" :class="{'d-tabs__header__right--alone': !isEditWorkHours}">
                <div class="label-with-toggle" @click="isEditWorkHours = !isEditWorkHours">
                  <label class="d-label">Indsæt arbejdstid</label>
                  <app-toggle :allowChanges="false" :propOn="isEditWorkHours"></app-toggle>
                </div>
              </div>
            </div>
            <div class="d-tabs__content" v-if="isEditWorkHours">
              <AssignHoursNormList
                :standardNettoHours="originalNettoTime"
                :standardHolidayHours="originalHolidayHours"
                :standardLocalAgreementHours="originalLocalAgreementHours"
                :isNetto="activeTab === 1"
                :isKindergarten="isKindergarten"
                :schoolYear="activeSchoolYear"
                :theEditUserNorm="theEditUserNorm"
                @onEditBrutto="setActiveTab(0)"
                @onEditNetto="setActiveTab(1)"
                @updated="setItemsToSave"
                @changedSum="setNettoTime"
                @onEditedStandardWorkingHours="setIsShowNewNettoModal($event)"
                @onOpenHolidaysSettings="openHolidaysSettingsModal"
                @onOpenLocalAgreementSettings="openLocalAgreementSettingsModal"
                @changedEmploymentRate="onChangedEmploymentRate">
              </AssignHoursNormList>
            </div>
            <div class="more-norms" v-if="!isKindergarten && (!isPoolsDeactivated || isAssignedPoolFromNormWhenPoolsDeactivated)">
              <div class="rest-calculation" v-if="isEditWorkHours && !isPoolsDeactivated">
                <label class="d-label">Rest / Ikke fordelt på puljer</label>
                {{ restCalculation }}
              </div>
              <ul class="brutto__items">
                <li v-for="(item, idx) in displayedNormPoolItems" :key="item.id" class="brutto__items__item__container">
                  <div class="label-with-toggle" @click="toggleItemById(item.id)">
                    <label class="d-label">Indsæt {{ getItemName(item) }}</label>
                    <app-toggle :allowChanges="false" :propOn="isItemToggledById(item.id)"></app-toggle>
                  </div>
                  <div class="brutto__items__item" v-if="isItemToggledById(item.id)">
                    <span class="norm-title">
                      {{ getItemName(item) }}
                      <span class="norm-title__sub"
                            v-if="prepFactor && item.id === 'assigned_preparation_hours'">
                        <template v-if="substitutePoolHoursForPrep !== null">
                          {{ prepFactor }} Forberedelesfaktor * ({{ hoursForTeaching }} UV + {{ substitutePoolHoursForPrep }} vikar)
                        </template>
                        <template v-else>
                          {{ prepFactor }} Forberedelesfaktor * {{ hoursForTeaching }} UV
                        </template>
                      </span>
                    </span>
                    <div class="d-input-group__input"
                         content='Forberedelse opdateres automatisk ift. hvad der er tildelt i "Undervisning"'
                         v-tippy="{
                      arrow: true,
                      animateFill: false,
                      animation : 'shift-away',
                      zIndex: '999999992',
                      boundary: 'window',
                      onShow: () => isShowPrepFactorTooltip(item)
                    }">
                      <div
                        v-if="isEmploymentRateChanged && (item.id !== 'assigned_preparation_hours' && prepFactor)"
                        class="employment-rate-calculator"
                      >
                        ({{ formatEmploymentRateText(item) }})
                      </div>
                      <span class="label">{{ item.unit ? item.unit : 'timer' }}</span>
                      <input :disabled="prepFactor && item.id === 'assigned_preparation_hours'" type="number"
                             v-model="item.hours" @change="onUpdatingHours(item, $event.target.value)"
                             @focus="$event.target.select()">
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="brutto__items__item__container brutto__items__item__container__notefield"
                 :class="{'brutto__items__item__container__notefield--alone' :isPoolsDeactivated}">
              <div class="label-with-toggle" @click="setIsShowAgreement">
                <label class="d-label">Indsæt en note til de valgte personer</label>
                <app-toggle :allowChanges="false" :propOn="isShowAgreement"></app-toggle>
              </div>
              <AppEIPWYZIWYG
                v-if="isShowAgreement"
                :isKeepOpen="true"
                :is-open="true"
                :isInTestOfSaveButton="false"
                @changed="updateAgreements">
              </AppEIPWYZIWYG>
              <h4 class="text-explainer" v-if="isShowAgreement">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="icon-archive tw-icon">
                  <path class="primary"
                        d="M5.23 3h13.54a2 2 0 0 1 1.98 2.22l-1.55 14A2 2 0 0 1 17.2 21H6.79a2 2 0 0 1-1.99-1.78l-1.55-14A2 2 0 0 1 5.23 3z"/>
                  <path class="secondary"
                        d="M10.59 14l-2.3-2.3a1 1 0 0 1 1.42-1.4L12 12.58l2.3-2.3a1 1 0 0 1 1.4 1.42L13.42 14l2.3 2.3a1 1 0 0 1-1.42 1.4L12 15.42l-2.3 2.3a1 1 0 1 1-1.4-1.42L10.58 14zM4 3h16a2 2 0 0 1 2 2v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V5c0-1.1.9-2 2-2z"/>
                </svg>
                Bemærk at hvis der står noget i personens notefelt i forvejen vil dette blive slettet
              </h4>
            </div>
          </div>
          <div class="brutto__users" :class="{'brutto__users--wide': showAllFields}">
            <div class="brutto__users__header brutto__users__header__filters">
              <DoFiltersFilter
                :users="usersSortedOnNameWithTags"
                :tags="tags"
                :selectedTags="appliedFilters"
                @clear="appliedFilters = []"
                @select="toggleFilter">
              </DoFiltersFilter>
              <div class="label-with-toggle" @click="showAllFields = !showAllFields">
                <label class="d-label">Vis alle felter</label>
                <app-toggle :allowChanges="false" :propOn="showAllFields"></app-toggle>
              </div>
            </div>
            <div class="norm-select-users__header">
              <div class="text-link" @click="toggleAllDisplayed">
                {{ isAllDisplayedSelected ? 'Fravælg alle' : 'Vælg alle' }}
              </div>
              <span> Viser {{ filteredUsers.length }} af {{ usersSortedOnName.length }}</span>
            </div>
            <div class="brutto__users__list">
              <div class="do-spinner__container" v-if="isLoadingAllUsers || isLoadingUserYears">
                <div class="do-spinner do-spinner--large"></div>
              </div>
              <table class="do-table" v-else>
                <thead>
                <tr>
                  <th></th>

                  <th @click="setNormSort('name')" class="is-clickable">
                    Navn
                    <span v-if="normSort.key === 'name'">{{ normSort.dir === 'asc' ? '▲' : '▼' }}</span>
                  </th>

                  <!-- Basis-kolonner: altid -->
                  <th
                    v-for="col in coreColumns"
                    :key="'h-core-' + col"
                    @click="setNormSort(col)"
                    class="is-clickable"
                  >
                    {{ shortNormTitle(col) }}
                    <span v-if="normSort.key === col">{{ normSort.dir === 'asc' ? '▲' : '▼' }}</span>
                  </th>

                  <!-- Ekstra felter: kun når showAllFields -->
                  <th
                    v-if="showAllFields"
                    v-for="col in extraColumns"
                    :key="'h-extra-' + col"
                    @click="setNormSort(col)"
                    class="is-clickable"
                  >
                    {{ shortNormTitle(col) }}
                    <span v-if="normSort.key === col">{{ normSort.dir === 'asc' ? '▲' : '▼' }}</span>
                  </th>
                  <th></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="row in normDisplayedRows"
                    :key="row.id"
                    @click="toggleUser(row)"
                    :class="{'is-selected': getIsUserSelected(row)}">

                  <!-- Checkbox -->
                  <td>
                    <div class="do-checkbox" :class="{'do-checkbox--selected': getIsUserSelected(row)}"></div>
                    <!--
                    <input type="checkbox"
                           :checked="getIsUserSelected(row)"
                           @change.stop="toggleUser(row)">
                           -->
                  </td>

                  <td class="bold">{{ row.name }}</td>

                  <!-- Basis-kolonner: altid -->
                  <td
                    v-for="col in coreColumns"
                    :key="'c-core-' + row.id + '-' + col"
                  >
                    {{ row.values[col] }}
                  </td>

                  <!-- Ekstra felter: kun når showAllFields -->
                  <td
                    v-if="showAllFields"
                    v-for="col in extraColumns"
                    :key="'c-extra-' + row.id + '-' + col"
                  >
                    {{ row.values[col] }}
                  </td>


                  <td>
                    <div class="icon__bg-circle d-edit-btn" @click.stop="editUserNorm(row)">
                      <span class="icon-wrench"></span>
                    </div>
                  </td>
                </tr>
                </tbody>

              </table>
            </div>
          </div>
        </div>
        <div class="brutto-container__footer">
          <button @click="isActive = false">Annullér</button>
          <button class="bttn bttn-primary"
                  :class="[{'bttn-primary--disabled': selectedUsers.length < 1}, {'bttn--loading': isSaving}]"
                  @click="setIsWarningActive(true)"
                  content="Der skal vælges minimum en bruger"
                  v-tippy="{
                    arrow: true,
                    onShow: () => selectedUsers.length < 1
                  }"
          >Gem
          </button>
        </div>
      </div>
    </DModal>
    <DModal v-if="isWarningActive" :isBgOverlay="true" :showClose="false" style="z-index: 999999999">
      <div class="brutto-warning" slot="insertComponent">
        <div class="brutto-warning__header">
          <h2>Gem og erstat?</h2>
          <div class="icon__bg-circle doc-modal__close" @click="isWarningActive = false">
            <span class="icon-cross2"></span>
          </div>
        </div>
        <div class="brutto-warning__body">
          <svg class="tw-icon tw-icon--red" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
               stroke-linecap="round" stroke-linejoin="round">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
            <line x1="12" y1="9" x2="12" y2="13"/>
            <line x1="12" y1="17" x2="12.01" y2="17"/>
          </svg>
          <p class="text-explainer">
            Du er ved at tildele arbejdstid på {{ nettoTime }} til de valgte brugere. Hvis der i forvejen er tildelt en
            arbejdstid vil dette blive erstattet.
          </p>
        </div>
        <div class="brutto-warning__footer">
          <button @click="isWarningActive = false">Annullér</button>
          <button class="bttn bttn-primary bttn-primary--small" @click="save" :class="[{'bttn--loading': isSaving}]">Gem
            og erstat
          </button>
        </div>
      </div>
    </DModal>
    <ModalConfirmation
      v-if="theNewNettoValue"
      :showClose="false"
      :isShowConfirmDeleteMessage="false"
      @close="setIsShowNewNettoModal(null)">
      <h4 slot="item">Vil du gemme {{ theNewNettoValue }} som den nye standard netto tid på skolen, så du ikke skal
        taste det næste gang?</h4>
      <template slot="confirm_buttons">
        <button class="do-bttn" @click="setIsShowNewNettoModal(null)">
          Ikke gem
        </button>
        <button class="do-bttn do-bttn--submit" ref="submit_bttn"
                @click="saveNewNettoTime">
          Gem som ny standard
        </button>
      </template>
    </ModalConfirmation>
    <ModalConfirmation
      v-if="isShowHolidaysSettingsModal"
      :showClose="false"
      :isShowConfirmDeleteMessage="false"
      @close="closeHolidaysSettingsModal">
      <div slot="item" id="holidays-settings">
        <h3>{{ holidaysSettingsReadOnly ? 'Helligdage i perioden' : 'Standard for søgnehelligdage' }}</h3>
        <p v-if="!holidaysSettingsReadOnly">Indtast den standard for søgnehelligdage som skal bruges i skoleåret
          <span class="bold">{{ activeSchoolYearName }}</span>. Værdien gælder ved fuld tid og bliver automatisk skaleret
          efter beskæftigelsesgrad.</p>
        <p v-else>Her vises helligdagene i den valgte periode. Skolens standard for søgnehelligdage kan kun redigeres,
          når perioden er hele skoleåret.</p>
        <div class="holidays-settings__list" v-if="holidaysSettingsList.length">
          <div class="holidays-settings__list__header">
            <span>Helligdage i perioden</span>
          </div>
          <ul>
            <li v-for="holiday in holidaysSettingsList"
                :key="holiday.date"
                :class="{'is-standard': holiday.isStandard, 'is-weekend': !holiday.isStandard}">
              <span class="holidays-settings__number" v-if="holiday.isStandard">{{ holiday.standardIndex }}</span>
              <span class="holidays-settings__number holidays-settings__number--empty" v-else>—</span>
              <span class="holidays-settings__name" v-if="holiday.name">{{ holiday.name }}</span>
              <span class="holidays-settings__date">{{ holiday.formatted }}</span>
              <span class="holidays-settings__tag" v-if="!holiday.isStandard">weekend</span>
            </li>
          </ul>
          <div class="holidays-settings__list__sum">
            {{ holidaysSettingsStandardCount }} standard dage × 7,4 timer =
            <span class="bold">{{ holidaysSettingsCalculatedValue }} timer</span>
          </div>
        </div>
        <div class="holidays-settings__input" v-if="!holidaysSettingsReadOnly">
          <label class="d-label">Timer ved fuld tid</label>
          <div class="d-input-group__input">
            <input type="number" v-model="holidaysSettingsValue" @focus="$event.target.select()">
            <span class="label">timer</span>
          </div>
        </div>
      </div>
      <template slot="confirm_buttons">
        <div class="holidays-settings__buttons">
        <button v-if="!holidaysSettingsReadOnly && originalHolidayHours > 0" class="do-bttn bttn--danger"
                @click="deleteHolidaysSettings">
          Nulstil
        </button>
        <div class="holidays-settings__buttons__right">
        <button class="do-bttn" @click="closeHolidaysSettingsModal">
          {{ holidaysSettingsReadOnly ? 'Luk' : 'Annullér' }}
        </button>
        <button v-if="!holidaysSettingsReadOnly" class="do-bttn do-bttn--submit" ref="submit_bttn"
                @click="saveHolidaysSettings">
          {{ originalHolidayHours > 0 ? 'Opdater' : 'Gem' }}
        </button>
        </div>
        </div>
      </template>
    </ModalConfirmation>
    <ModalConfirmation
      v-if="isShowLocalAgreementSettingsModal"
      :showClose="false"
      :isShowConfirmDeleteMessage="false"
      @close="closeLocalAgreementSettingsModal">
      <div slot="item" id="holidays-settings">
        <h3>Standard for tilpasning til lokalaftale</h3>
        <p>Indtast den standardværdi for tilpasning til lokalaftale, som skal bruges. Værdien gælder ved fuld tid og
          bliver automatisk skaleret efter beskæftigelsesgrad.</p>
        <div class="holidays-settings__input">
          <label class="d-label">Timer ved fuld tid</label>
          <div class="d-input-group__input">
            <input type="number" v-model="localAgreementSettingsValue" @focus="$event.target.select()">
            <span class="label">timer</span>
          </div>
        </div>
      </div>
      <template slot="confirm_buttons">
        <div class="holidays-settings__buttons">
          <button v-if="originalLocalAgreementHours > 0" class="do-bttn bttn--danger"
                  @click="deleteLocalAgreementSettings">
            Nulstil
          </button>
          <div class="holidays-settings__buttons__right">
            <button class="do-bttn" @click="closeLocalAgreementSettingsModal">
              Annullér
            </button>
            <button class="do-bttn do-bttn--submit" ref="submit_bttn"
                    @click="saveLocalAgreementSettings">
              {{ originalLocalAgreementHours > 0 ? 'Opdater' : 'Gem' }}
            </button>
          </div>
        </div>
      </template>
    </ModalConfirmation>
    <ModalConfirmation
      v-if="theNewStandardHoursForPool"
      :showClose="false"
      :isShowConfirmDeleteMessage="false"
      @close="setTheNewStandardHoursForPool(null)">
      <h4 slot="item" style="font-weight: normal;">
        Vil du gemme <span class="bold">{{ theNewStandardHoursForPool.hours }} timer</span> som den nye standard for
        <span class="bold">{{ theNewStandardHoursForPool.name }}-puljen</span>, så du ikke behøver at indtaste det næste
        gang?
      </h4>
      <template slot="confirm_buttons">
        <button class="do-bttn" @click="setTheNewStandardHoursForPool(null)">
          Ikke gem
        </button>
        <button class="do-bttn do-bttn--submit" ref="submit_bttn"
                @click="saveNewStandardHours">
          Gem som ny standard
        </button>
      </template>
    </ModalConfirmation>
    <ModalConfirmation
      v-if="isModalAutoCalculateOpen"
      :showClose="false"
      :isShowConfirmDeleteMessage="false"
      @close="isModalAutoCalculateOpen = false">
      <h4 slot="item" style="font-weight: normal;">
        <h3 class="marg-1-bottom">Skal puljer automatisk opdateres?</h3>
        <ul>
          <li v-for="checkedItem in checkedItemsToUpdate" :key="checkedItem.id">
            <b>{{ checkedItem.name }}:</b> {{ formatEmploymentRateText(checkedItem, true) }}
          </li>
        </ul>
      </h4>
      <template slot="confirm_buttons">
        <button class="do-bttn" @click="isModalAutoCalculateOpen = false">
          Ikke opdatér
        </button>
        <button class="do-bttn do-bttn--submit" ref="submit_bttn"
                @click="updateActivePoolsFromEmploymentRate">
          Opdatér puljer
        </button>
      </template>
    </ModalConfirmation>
    <AssignHoursNormEditIUserModal
      v-if="theEditUser"
      :user="theEditUser"
      :schoolYear="activeSchoolYear"
      :schoolId="schoolId"
      @updated="onUpdatedUserNorm"
      @close="setTheEditUser(null)">
    </AssignHoursNormEditIUserModal>
  </div>
</template>

<script>
import DModal from '../common/DModal'
import {mapGetters} from 'vuex'
import docendo from '../../docendo'
import eventbus from '../../eventbus'
import AppEIPWYZIWYG from '../common/AppEIPWYZIWYG'
import AppToggle from '../common/AppToggle'
import AssignHoursNormList from './AssignHoursNormList'
import ModalConfirmation from '../Modals/ModalConfirmation.vue'
import DoFiltersFilter from '../DoFilters/DoFiltersFilter.vue'
import AssignHoursNormEditIUserModal from './AssignHoursNormEditIUserModal.vue'

export default {
  components: {
    AssignHoursNormEditIUserModal,
    DoFiltersFilter, ModalConfirmation, AppToggle, DModal, AppEIPWYZIWYG, AssignHoursNormList
  },
  props: {
    tags: {
      default: () => []
    },
    isKindergarten: {
      type: Boolean,
      default: false
    },
    isLocalPoolActivated: {
      type: Boolean,
      default: false
    },
    prepFactor: {
      default: null
    },
    isPoolsDeactivated: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      theEditUser: null,
      showAllFields: false,
      sort: {
        key: 'vAssignedTotalHours',
        dir: 'desc'
      },
      normSort: {key: 'name', dir: 'asc'},
      theEmploymentRate: 1, // 37/37 == 1
      theNewNettoValue: null,
      isShowHolidaysSettingsModal: false,
      holidaysSettingsValue: 0,
      holidaysSettingsList: [],
      holidaysSettingsStandardCount: 0,
      holidaysSettingsCalculatedValue: 0,
      holidaysSettingsReadOnly: false,
      originalHolidayHours: 0,
      isShowLocalAgreementSettingsModal: false,
      localAgreementSettingsValue: 0,
      originalLocalAgreementHours: 0,
      isWarningActive: false,
      isActive: false,
      isSaving: false,
      selectedUsers: [],
      appliedFilters: [],
      nettoItems: [],
      items: [
        {id: 'assigned_teaching_hours', name: 'Undervisning', hours: 800, isChecked: false},
        {id: 'assigned_additional_task_hours', name: 'Øvrige opgaver', hours: 400, isChecked: false},
        {id: 'assigned_preparation_hours', name: 'Forberedelse', hours: 400, isChecked: false},
        {id: 'assigned_pool_hours', name: 'Lokalpulje', hours: 80, isChecked: false},
        {id: 'substitute_pool_hours', name: 'Vikartimer', hours: 0, isChecked: false},
        {id: 'assigned_club_hours', name: 'SFO-timer', hours: 0, isChecked: false}
      ],
      originalItems: [],
      agreements: '',
      isShowAgreement: false,
      activeTab: 0,
      itemsToSave: [],
      nettoTime: 1686.1,
      originalNettoTime: 1686.1,
      theEditUserNorm: null,
      theNewStandardHoursForPool: null, // {id: 'assigned_teaching_hours', name: 'Undervisning', hours: 750, isChecked: false},
      isAutoCalculateHoursFromEmploymentRate: false,
      isModalAutoCalculateOpen: false,
      isEditWorkHours: true,
      updatesHasHappened: false,
      userYearsByUserId: {},
      isLoadingUserYears: false
    }
  },
  computed: {
    ...mapGetters([
      'usersSortedOnName',
      'isAssignedPoolFromNormWhenPoolsDeactivated'
    ]),
    displayedNormPoolItems () {
      if (this.isPoolsDeactivated && this.isAssignedPoolFromNormWhenPoolsDeactivated) {
        return this.items.filter(item => item.id === 'assigned_pool_hours')
      }
      return this.items
    },
    isLoadingAllUsers () {
      return this.$store.state.isLoadingAllUsers
    },
    localPoolTitle () {
      const title = this.$store.getters.localPoolTitle
      return title || this.$t('vue2.task_overview.pool')
    },
    coreColumns () {
      return ['Ansættelsesgrad', 'Timeansættelse pr. uge']
    },
    // Saml alle mulige felter (uden hidden/periode)
    normColumns () {
      const cols = {}
      const users = this.filteredUsers || []
      for (let i = 0; i < users.length; i++) {
        const u = users[i]
        const year = u && u.vYear ? u.vYear : {}
        const norm = year && Array.isArray(year.norm) ? year.norm : []
        for (let j = 0; j < norm.length; j++) {
          const entry = norm[j]
          if (!entry || !entry.title) continue
          if (entry.title.indexOf('hidden_') === 0) continue
          if (entry.title === 'Periode') continue
          cols[entry.title] = true
        }
      }
      // sørg for at core altid er med
      this.coreColumns.forEach(c => { cols[c] = true })
      return Object.keys(cols)
    },
    // Ekstra felter = alle minus core (bruges kun når showAllFields)
    extraColumns () {
      return this.normColumns.filter(c => this.coreColumns.indexOf(c) === -1)
    },
    isAllDisplayedSelected () {
      const rows = this.normDisplayedRows
      if (!rows.length) return false
      for (let i = 0; i < rows.length; i++) {
        const r = rows[i]
        if (!this.getIsUserSelected(r)) return false
      }
      return true
    },
    schoolSettings () {
      return this.$store.state.schoolSettings
    },
    schoolId () {
      return this.$store.getters.schoolId // this.$route && this.$route.params.school_id ? this.$route.params.school_id :
    },
    activeSchoolYear () {
      return this.$store.state.localActivatedSchoolYear
    },
    activeSchoolYearName () {
      return this.activeSchoolYear && this.activeSchoolYear.name ? this.activeSchoolYear.name : ''
    },
    restCalculation () {
      const sum = this.items
        .filter(item => item.isChecked)
        .reduce((sum, item) => sum + Number(item.hours), 0)
      return (this.nettoTime - sum).toFixed(2)
    },
    checkedItemsToUpdate () {
      return this.items
        .filter(item => !this.prepFactor || item.id !== 'assigned_preparation_hours')
        .filter(item => item.isChecked)
    },
    isEmploymentRateChanged () {
      return this.isPoolsDeactivated ? false : Number(this.theEmploymentRate) !== 1
    },
    usersSortedOnNameWithTags () {
      return this.usersSortedOnName.map(user => {
        user.tags = user.user_tags
        return user
      })
    },
    filteredUsers () {
      const enriched = this.usersSortedOnNameWithTags.map(user => {
        const cy = this.getYearForActiveSchoolYear(user) || {}
        const hasHours = typeof cy.assigned_total_hours !== 'undefined' && cy.assigned_total_hours !== null
        const hours = hasHours ? Number(cy.assigned_total_hours) : 0

        return {
          ...user,
          vYear: cy,
          vTags: user && user.user_tags ? user.user_tags : [],
          vName: user && user.name ? user.name : '',
          vAssignedTotalHours: isNaN(hours) ? 0 : hours,
          vHasAssignedTotalHours: !!hasHours
        }
      })

      const filtered = !this.appliedFilters.length
        ? enriched
        : enriched.filter(user =>
          user.vTags && this.appliedFilters.some(tag => user.vTags.indexOf(tag) > -1)
        )

      return filtered.slice().sort((a, b) => {
        if (b.vAssignedTotalHours !== a.vAssignedTotalHours) {
          return b.vAssignedTotalHours - a.vAssignedTotalHours
        }
        return String(a.vName).localeCompare(String(b.vName), 'da-DK')
      })
    },
    displayedUsers () {
      const list = this.filteredUsers.slice()

      // vælg comparator udfra key-type
      if (this.sort.key === 'vAssignedTotalHours') {
        list.sort((a, b) => {
          const av = Number(a.vAssignedTotalHours || 0)
          const bv = Number(b.vAssignedTotalHours || 0)
          return this.sort.dir === 'asc' ? av - bv : bv - av
        })
      } else if (this.sort.key === 'name') {
        list.sort((a, b) => {
          const an = String(a.name || '')
          const bn = String(b.name || '')
          const cmp = an.localeCompare(bn, 'da-DK')
          return this.sort.dir === 'asc' ? cmp : -cmp
        })
      }

      return list
    },
    hoursForTeaching () {
      const idx = this.items.findIndex(item => item.id === 'assigned_teaching_hours')
      return this.items[idx].hours
    },
    isPrepFactorForSubstitutePools () {
      return !!(this.schoolSettings && this.schoolSettings['prepFactorForSubstitutePools'])
    },
    /**
     * Vikartimer der skal medregnes i forberedelsen. Kun når indstillingen er aktiv
     * og Vikartimer-puljen er slået til i normberegningen — ellers null.
     */
    substitutePoolHoursForPrep () {
      if (!this.isPrepFactorForSubstitutePools) {
        return null
      }
      const item = this.items.find(item => item.id === 'substitute_pool_hours')
      if (!item || !item.isChecked) {
        return null
      }
      const hours = Number(item.hours)
      return isNaN(hours) ? 0 : hours
    },
    normRows () {
      const users = this.filteredUsers || []
      return users.map(u => {
        const year = u && u.vYear ? u.vYear : {}
        const norm = year && Array.isArray(year.norm) ? year.norm : []

        // Start: udfyld basis-kolonner altid
        const values = {}
        for (let i = 0; i < this.coreColumns.length; i++) values[this.coreColumns[i]] = ''

        // Udfyld værdier for alle kendte felter
        for (let k = 0; k < norm.length; k++) {
          const e = norm[k]
          if (!e || !e.title) continue
          if (e.title.indexOf('hidden_') === 0) continue
          if (e.title === 'Periode') continue
          values[e.title] = e.value
        }

        // Hvis showAllFields: sørg for at alle ekstra felter findes som keys
        if (this.showAllFields) {
          for (let i = 0; i < this.extraColumns.length; i++) {
            const col = this.extraColumns[i]
            if (values[col] === undefined) values[col] = ''
          }
        }

        const hasHours = year && typeof year.assigned_total_hours !== 'undefined' && year.assigned_total_hours !== null
        const hours = hasHours ? Number(year.assigned_total_hours) : 0

        return {
          id: u.id,
          name: u && u.name ? u.name : '',
          vAssignedTotalHours: isNaN(hours) ? 0 : hours,
          values: values,
          _rawUser: u
        }
      })
    },
    normDisplayedRows () {
      const list = this.normRows.slice()
      const key = this.normSort.key
      const dir = this.normSort.dir

      // tillad sortering på coreColumns, selv når showAllFields er false
      const canSortCoreWhenCollapsed = this.coreColumns.indexOf(key) > -1

      if (!this.showAllFields && key !== 'name' && !canSortCoreWhenCollapsed) {
        return list.sort((a, b) => {
          const an = String(a.name || '')
          const bn = String(b.name || '')
          const cmp = an.localeCompare(bn, 'da-DK')
          return cmp
        })
      }

      if (key === 'name') {
        list.sort((a, b) => {
          const an = String(a.name || '')
          const bn = String(b.name || '')
          const cmp = an.localeCompare(bn, 'da-DK')
          return dir === 'asc' ? cmp : -cmp
        })
        return list
      }

      if (key === 'vAssignedTotalHours') {
        list.sort((a, b) => {
          const av = Number(a.vAssignedTotalHours || 0)
          const bv = Number(b.vAssignedTotalHours || 0)
          return dir === 'asc' ? av - bv : bv - av
        })
        return list
      }

      // Dynamisk eller core-kolonne (også når showAllFields = false for core)
      function toNum (val) {
        const s = String(val === undefined || val === null ? '' : val)
          .replace('%', '')
          .replace(',', '.')
        const n = parseFloat(s)
        return isNaN(n) ? null : n
      }

      list.sort((a, b) => {
        const avRaw = a.values[key]
        const bvRaw = b.values[key]
        const avNum = toNum(avRaw)
        const bvNum = toNum(bvRaw)

        if (avNum !== null && bvNum !== null) {
          return dir === 'asc' ? avNum - bvNum : bvNum - avNum
        }

        const at = String(avRaw === undefined || avRaw === null ? '' : avRaw)
        const bt = String(bvRaw === undefined || bvRaw === null ? '' : bvRaw)
        const cmp = at.localeCompare(bt, 'da-DK')
        return dir === 'asc' ? cmp : -cmp
      })
      return list
    }
  },
  methods: {
    getItemName (item) {
      if (item && item.id === 'assigned_pool_hours') {
        return this.localPoolTitle
      }
      return item && item.name ? item.name : ''
    },
    onUpdatedUserNorm () {
      this.updatesHasHappened = true
      this.setTheEditUser(null)
      this.loadUserYearsForActiveSchoolYear()
    },
    loadUserYearsForActiveSchoolYear () {
      if (!this.activeSchoolYear || !this.activeSchoolYear.id) {
        this.userYearsByUserId = {}
        return
      }
      this.isLoadingUserYears = true
      docendo.schoolUserYearsList(this.schoolId, this.activeSchoolYear.id, null, success => {
        const list = Array.isArray(success) ? success : []
        const byUserId = {}
        for (let i = 0; i < list.length; i++) {
          const userYear = list[i]
          if (userYear && userYear.user_id) {
            byUserId[userYear.user_id] = userYear
          }
        }
        this.userYearsByUserId = byUserId
        this.isLoadingUserYears = false
      }, failure => {
        this.userYearsByUserId = {}
        this.isLoadingUserYears = false
        console.log('schoolUserYearsList failed', failure)
      })
    },
    getYearForActiveSchoolYear (user) {
      if (!user || !user.id) return null
      return this.userYearsByUserId[user.id] || null
    },
    setTheEditUser (user) {
      if (user) {
        this.selectedUsers = [user.id]
      } else {
        this.selectedUsers = []
      }
      this.theEditUser = user
    },
    toggleAllDisplayed () {
      if (this.isAllDisplayedSelected) {
        // Fravælg alle viste
        const ids = this.normDisplayedRows.map(r => r.id)
        this.selectedUsers = this.selectedUsers.filter(id => ids.indexOf(id) === -1)
        return
      }
      // Vælg alle viste
      const add = this.normDisplayedRows.map(r => r.id)
      const set = {}
      for (let i = 0; i < this.selectedUsers.length; i++) set[this.selectedUsers[i]] = true
      for (let j = 0; j < add.length; j++) set[add[j]] = true
      this.selectedUsers = Object.keys(set).map(k => k * 1)
    },

    // Korte kolonne-titler til thead
    shortNormTitle (title) {
      // Hårde mappings først
      const map = {
        'Ansættelsesgrad': 'Ans.grad',
        'Timeansættelse pr. uge': 'Timer/uge',
        'Søgnehelligdage': 'Søgnehel.',
        '6. Ferieuge': '6. ferieuge',
        'Bruttotid': 'Brutto',
        'Arbejdstid': 'Netto'
      }
      if (map[title]) return map[title]

      // Bløde regler til fallback
      let t = String(title)
      t = t.replace(' pr. ', '/')
      t = t.replace(' pr ', '/')

      // Afkort meget lange titler pænt
      const max = 16
      if (t.length > max) t = t.slice(0, max - 1) + '…'

      return t
    },
    setNormSort (key) {
      if (this.normSort.key === key) {
        this.normSort.dir = this.normSort.dir === 'asc' ? 'desc' : 'asc'
        return
      }
      this.normSort.key = key
      this.normSort.dir = key === 'name' ? 'asc' : 'desc'
    },
    setIsWarningActive (bool) {
      if (bool && this.isEditWorkHours) {
        this.isWarningActive = true
        return
      }
      this.save()
    },
    setHoursFromEmploymentRate (itemToUpdate) {
      const idx = this.items.findIndex(item => item.id === itemToUpdate.id)
      if (idx === -1) return // Sikrer, at vi ikke prøver at ændre noget, der ikke findes

      const item = this.items[idx]
      const originalItem = this.findOriginalItem(item)
      const newHours = parseFloat((originalItem.hours * this.theEmploymentRate).toFixed(2)) // Sikrer taltype

      this.$set(this.items, idx, {...item, hours: newHours}) // Vue reagerer korrekt på ændringen
    },
    updateActivePoolsFromEmploymentRate () {
      this.checkedItemsToUpdate.forEach(checkedItem => {
        this.setHoursFromEmploymentRate(checkedItem)
      })
      this.isModalAutoCalculateOpen = false
      this.updatePrepHoursFromTeaching()
    },
    formatEmploymentRateText (item, showResult = false) {
      const originalHours = this.findOriginalItem(item).hours
      const employmentRatePercentage = (this.theEmploymentRate * 100).toFixed(0) + '%'
      const result = (originalHours * this.theEmploymentRate).toFixed(2) // Beregnet resultat

      return showResult
        ? `${originalHours} timer * ${employmentRatePercentage} = ${result} timer`
        : `${originalHours}t * ${employmentRatePercentage}`
    },
    onChangedEmploymentRate (rate) {
      if (this.isPoolsDeactivated) {
        return
      }
      this.theEmploymentRate = rate
      this.isModalAutoCalculateOpen = this.items.some(item => item.isChecked)
    },
    isShowPrepFactorTooltip (item) {
      return item.id === 'assigned_preparation_hours' && this.prepFactor !== null
    },
    saveNewNettoTime () {
      const val = this.theNewNettoValue * 1
      this.$store.dispatch('updateSchoolSettings', {'nettoTime': val})
      this.originalNettoTime = val
      setTimeout(_ => {
        this.setIsShowNewNettoModal(null)
      }, 0)
    },
    setIsShowNewNettoModal (val) {
      this.theNewNettoValue = val
    },
    openHolidaysSettingsModal (payload) {
      this.holidaysSettingsValue = payload.fullTimeValue
      this.holidaysSettingsList = payload.holidays || []
      this.holidaysSettingsStandardCount = payload.standardDayCount || 0
      this.holidaysSettingsCalculatedValue = payload.calculatedFullTimeValue || 0
      this.holidaysSettingsReadOnly = !!payload.isReadOnly
      this.isShowHolidaysSettingsModal = true
    },
    closeHolidaysSettingsModal () {
      this.isShowHolidaysSettingsModal = false
    },
    saveHolidaysSettings () {
      const val = this.holidaysSettingsValue * 1
      if (!val || val <= 0) {
        return
      }
      this.$store.dispatch('updateSchoolSettingsForSchoolYear', {'holidays': val})
      this.originalHolidayHours = val
      setTimeout(_ => {
        this.closeHolidaysSettingsModal()
      }, 0)
    },
    deleteHolidaysSettings () {
      this.$store.dispatch('deleteSchoolSettingForSchoolYear', 'holidays')
      this.originalHolidayHours = 0
      setTimeout(_ => {
        this.closeHolidaysSettingsModal()
      }, 0)
    },
    openLocalAgreementSettingsModal (payload) {
      this.localAgreementSettingsValue = payload.fullTimeValue
      this.isShowLocalAgreementSettingsModal = true
    },
    closeLocalAgreementSettingsModal () {
      this.isShowLocalAgreementSettingsModal = false
    },
    saveLocalAgreementSettings () {
      const val = this.localAgreementSettingsValue * 1
      if (!val || val <= 0) {
        return
      }
      this.$store.dispatch('updateSchoolSettings', {'local_agreement_adjustment': val})
      this.originalLocalAgreementHours = val
      setTimeout(_ => {
        this.closeLocalAgreementSettingsModal()
      }, 0)
    },
    deleteLocalAgreementSettings () {
      this.$store.dispatch('updateSchoolSettings', {'local_agreement_adjustment': null})
      this.originalLocalAgreementHours = 0
      setTimeout(_ => {
        this.closeLocalAgreementSettingsModal()
      }, 0)
    },
    setTheNewStandardHoursForPool (obj = null) {
      this.theNewStandardHoursForPool = obj
    },
    saveNewStandardHours () {
      const hours = Number(this.theNewStandardHoursForPool.hours)
      const key = this.theNewStandardHoursForPool.id

      this.$store.dispatch('updateSchoolSettings', {[key]: hours})

      const originalItem = this.originalItems.find(item => item.id === this.theNewStandardHoursForPool.id)
      if (originalItem) {
        originalItem.hours = hours
      }
      setTimeout(() => {
        this.setTheNewStandardHoursForPool(null)
      }, 0)
    },
    setIsNormModal () {
      this.$store.dispatch('getUsersFromSchoolId', this.schoolId)
      this.loadUserYearsForActiveSchoolYear()
      this.theEmploymentRate = 1
      this.updateItemsWithSchoolSettings()
      if (this.schoolSettings && (this.schoolSettings['netto_time'] || this.schoolSettings['nettoTime'])) {
        const nettTime = this.schoolSettings['netto_time'] || this.schoolSettings['nettoTime']
        this.nettoTime = nettTime
        this.originalNettoTime = nettTime
      }
      this.originalHolidayHours = this.getHolidayHoursFromSchoolYearSettings()
      this.originalLocalAgreementHours = this.getLocalAgreementHoursFromSchoolSettings()
      this.isActive = true
      this.updatePrepHoursFromTeaching()
    },
    getLocalAgreementHoursFromSchoolSettings () {
      if (this.schoolSettings && this.schoolSettings['local_agreement_adjustment']) {
        return this.schoolSettings['local_agreement_adjustment'] * 1
      }
      return 0
    },
    getHolidayHoursFromSchoolYearSettings () {
      if (!this.schoolSettings || !this.activeSchoolYear || !this.activeSchoolYear.id) {
        return 0
      }
      const propSchoolYear = 'school_year_' + this.activeSchoolYear.id
      const settingsForYear = this.schoolSettings[propSchoolYear]
      if (settingsForYear && settingsForYear['holidays']) {
        return settingsForYear['holidays'] * 1
      }
      return 0
    },
    updatePrepHoursFromTeaching () {
      if (!this.prepFactor) {
        return
      }
      const teachingHours = Number(this.hoursForTeaching) || 0
      const substituteHours = this.substitutePoolHoursForPrep !== null ? this.substitutePoolHoursForPrep : 0
      const thePrep = (teachingHours + substituteHours) * this.prepFactor
      const roundedPrep = parseFloat(thePrep.toFixed(2))
      const idx = this.items.findIndex(hoursItem => hoursItem.id === 'assigned_preparation_hours')
      this.items[idx].hours = roundedPrep
    },
    onUpdatingHours (item, val) {
      const originalItem = this.originalItems.find(item => item.id === item.id)
      const originalVal = originalItem.hours
      const newVal = val * 1
      if (!this.isEmploymentRateChanged && originalVal !== newVal) {
        this.setTheNewStandardHoursForPool(item)
      }
      this.updatePrepHoursFromTeaching()
    },
    findOriginalItem (item) {
      return this.originalItems.find(originalItem => originalItem.id === item.id)
    },
    toggleItem (idx) {
      const item = this.items[idx]
      this.items[idx].isChecked = !this.items[idx].isChecked
      if (this.prepFactor && item.id === 'assigned_preparation_hours') {
        return
      }
      if (this.isEmploymentRateChanged) {
        this.setHoursFromEmploymentRate(item)
        this.updatePrepHoursFromTeaching()
      } else if (item.id === 'substitute_pool_hours') {
        // Vikartimer kan indgå i forberedelsen, så prep skal genberegnes ved til-/fravalg
        this.updatePrepHoursFromTeaching()
      }
    },
    toggleItemById (itemId) {
      const idx = this.items.findIndex(item => item.id === itemId)
      if (idx > -1) {
        this.toggleItem(idx)
      }
    },
    isItemToggled (idx) {
      return this.items[idx].isChecked
    },
    isItemToggledById (itemId) {
      const idx = this.items.findIndex(item => item.id === itemId)
      return idx > -1 ? this.isItemToggled(idx) : false
    },
    setNettoTime (time) {
      this.nettoTime = time
    },
    setItemsToSave (arr) {
      this.itemsToSave = arr
    },
    setActiveTab (num) {
      this.activeTab = num
      if (num === 1) {
        this.nettoTime = this.originalNettoTime
      }
    },
    getIsActiveTab (num) {
      return this.activeTab === num
    },
    setIsShowAgreement () {
      this.isShowAgreement = !this.isShowAgreement
    },
    toggleAll () {
      if (this.selectedUsers.length > 0) {
        this.selectedUsers = []
      } else {
        this.selectedUsers = []
        this.filteredUsers.forEach(user => this.selectedUsers.push(user.id))
      }
    },
    getIsUserSelected (user) {
      const idx = this.selectedUsers.findIndex(selectedUser => selectedUser === user.id)
      return idx > -1
    },
    toggleUser (user) {
      const idx = this.selectedUsers.findIndex(selectedUser => selectedUser === user.id)
      if (idx > -1) {
        this.selectedUsers.splice(idx, 1)
      } else {
        this.selectedUsers.push(user.id)
      }
    },
    toggleFilter (tag) {
      this.selectedUsers = []
      const idx = this.appliedFilters.findIndex(filter => filter === tag) // Rettet her

      if (idx < 0) {
        this.appliedFilters.push(tag)
      } else {
        this.appliedFilters.splice(idx, 1)
      }
    },
    close () {
      this.userYearsByUserId = {}
      this.isActive = false
      this.selectedUsers = []
      if (this.updatesHasHappened) {
        this.$emit('updateUsersHours')
      }
    },
    save () {
      if (this.selectedUsers.length < 1) return
      if (!this.activeSchoolYear || !this.activeSchoolYear.name) {
        eventbus.toast = {text: 'Skoleår er ikke indlæst endnu', success: false}
        return
      }

      function validateNumber (item) {
        const itemsNotToValidate = [
          'hidden_ansættelsesgrad',
          'Periode',
          'hidden_periode_start',
          'hidden_periode_end',
          'Ansættelsesgrad'
        ]

        if (itemsNotToValidate.indexOf(item.title) > -1) {
          return item.value
        }

        const val = item.hours * 1
        return val.toFixed(2)
      }

      const data = {}

      if (this.isEditWorkHours) {
        this.isSaving = true

        const itemsToSave = this.itemsToSave.map(item => {
          return {
            title: item.title,
            value: validateNumber(item)
          }
        })

        itemsToSave.push({
          title: 'Arbejdstid',
          value: this.nettoTime
        })

        data.norm = itemsToSave
        data.assigned_total_hours = this.nettoTime
      }

      if (this.isShowAgreement) {
        data.agreements = this.agreements
      }

      const activatedItems = this.items.filter(item => item.isChecked)
      activatedItems.forEach(item => {
        data[item.id] = item.hours
      })

      const dataToSave = this.selectedUsers.map(userId => {
        return {
          user_id: userId,
          data: data
        }
      })

      docendo.bulkSchoolUserYearUpdate(
        this.schoolId,
        this.activeSchoolYear.name,
        dataToSave,
        success => {
          this.reset()
          this.$emit('updateUsersHours')
          this.close()
          eventbus.toast = {text: 'Gemt', success: true}
        },
        failure => {
          eventbus.toast = {text: 'Noget gik galt', success: false}
        }
      )
    },
    reset () {
      this.isSaving = false
      this.isEditWorkHours = true
      this.selectedUsers = []
      this.isShowAgreement = false
      this.agreements = ''
      this.items = JSON.parse(JSON.stringify(this.originalItems))
      this.isWarningActive = false
    },
    updateAgreements (val) {
      this.agreements = val
    },
    readUserNorm (user) {
      if (!this.activeSchoolYear || !this.activeSchoolYear.name) return
      docendo.schoolUserYearRead(this.schoolId, user.id, this.activeSchoolYear.name, success => {
        this.theEditUserNorm = success.norm ? success.norm : []
        this.userAgreements = success.agreements ? success.agreements : ''
      }, failure => {
        console.log('failed!')
      })
    },
    editUserNorm (user) {
      this.setTheEditUser(user)
      // this.readUserNorm(user)
    },
    updateItemsWithSchoolSettings () {
      this.items.forEach(item => {
        const setting = this.schoolSettings && this.schoolSettings[item.id]
        if (setting) {
          this.$set(item, 'hours', setting) // Sikrer at Vue registrerer ændringen
        }
      })
      this.originalItems.forEach(item => {
        const setting = this.schoolSettings && this.schoolSettings[item.id]
        if (setting) {
          this.$set(item, 'hours', setting) // Sikrer at Vue registrerer ændringen
        }
      })
    }
  },
  beforeMount () {
    if (!this.isLocalPoolActivated) {
      const idx = this.items.findIndex(item => item.id === 'assigned_pool_hours')
      this.items.splice(idx, 1)
    }
  },
  mounted () {
    this.originalItems = JSON.parse(JSON.stringify(this.items))
  }
}
</script>

<style>
@import '../../assets/css/variables.css';

.brutto {
  position: relative;
}

.is-clickable {
  cursor: pointer;
}

.brutto input[type="number"] {
  background: #ffffff;
}

.brutto-container {
  background: #fff;
  border-radius: 4px;
}

.brutto-container__header {
  padding: 1rem;
  border-bottom: 1px solid #dddddd;
}

.brutto-container__body {
  display: flex;
  background: var(--bg-grey);
  min-height: 65vh;
  max-height: calc(100vh - (52px + 53px));
  overflow-y: auto;
  overscroll-behavior: contain;
}

.brutto-container__body.brutto-container__body--wide {
  width: 100vw;
}

.brutto-container__body__left {
  width: 500px;
  border-right: 1px solid #dddddd;
  padding: 1rem;
}

.brutto__items {
  margin: 0;
  padding: 1rem;
  font-weight: normal;
}

.brutto__users.brutto__users--wide {
  width: calc(100vw - 500px) !important;
}

.brutto__items__item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}

.brutto__items__item.brutto__items__item--netto-hours {
  margin-bottom: 0;
}


.norm-title, .norm-title + label {
  user-select: none;
}

.brutto__items__item > input[type="text"],
.brutto__items__item > input[type="number"],
.brutto__items__item > input[type="range"] {
  width: 150px;
  font-weight: normal;
  padding: 0;
}

.brutto__items__item input[type="number"]:not([disabled]) {
  background: #ffffff;
}

.brutto__items__item input[type="number"] {
  width: 100px;
}

.brutto__items__item .d-input-group {
  display: flex;
  align-items: center;
}

.brutto__items__item .d-input-group label {
  margin-right: 2px;
}

.brutto-container__footer {
  padding: 1rem;
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #dddddd;
}

.brutto-container__footer > .bttn:last-child {
  margin-left: 1rem;
}

.brutto__users__header {
  border-bottom: 1px solid #dddddd;
  padding: 1rem;
}

.brutto__users__header__filters {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.brutto__users__header__filters .label-with-toggle {
  display: flex;
  gap: 0.5rem;
}

.brutto__users__user {
  position: relative;
  display: flex;
  align-items: center;
  padding: 1rem;
  cursor: pointer;
  transition: background-color 0.15s, transform 0.25s;
}

.brutto__users__user:hover {
  background-color: aliceblue;
}

.brutto__users__user:active {
  transform: scale(0.98);
}

.brutto__users__user:before {
  content: '';
  font-family: 'icomoon' !important;
  color: #ffffff;
  display: flex;
  font-size: 9px;
  align-items: center;
  justify-content: center;
  width: 12px;
  height: 12px;
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  margin-right: 0.5rem;
  cursor: pointer;
  transition: background-color 0.15s;
}

.brutto__users__user.is-selected:before {
  content: '\ED72';
  background-color: var(--blue);
  border-color: var(--blue);
}

.brutto__users__list {
  max-height: 65vh;
  overflow: auto;
}

.brutto__users__list > .do-table tbody {
  background: #edf0f5;
}

.brutto__users__list > .do-table tbody tr {
  border-bottom: 1px solid #e2e8f0;
  font-weight: normal;
  cursor: pointer;
  position: relative;
}

.brutto__users__list > .do-table tbody tr:hover {
  background-color: aliceblue;
}

.brutto__users__list > .do-table tbody tr td:not(:last-child) {
  border-right: 1px solid #e2e8f0;
}

.brutto__users__list > .do-table thead tr th:first-child,
.brutto__users__list > .do-table tbody tr td:first-child {
  width: 20px;
  border-right: none;
}

.brutto__users__list > .do-table thead tr th:nth-child(2),
.brutto__users__list > .do-table tbody tr td:nth-child(2) {
  width: 200px;
}

.brutto__users__list > .do-table thead tr th:nth-last-child(2),
.brutto__users__list > .do-table tbody tr td:nth-last-child(2) {
  border-right: none;
}

.brutto__users__list > .do-table thead tr th:last-child,
.brutto__users__list > .do-table tbody tr td:last-child {
  width: 20px;
}

.d-input-group__input {
  display: flex;
  align-items: center;
  font-weight: normal;
}

.d-input-group__input span {
  margin-right: 5px;
  font-size: 0.85rem;
}

.brutto-container-denmark .brutto__users {
  width: 450px;
}

.brutto__items__item__netto {
  margin-top: 2rem;
}

.norm-select-users__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.9rem;
  padding: 0.25rem 1rem;
  font-weight: normal;
}

.brutto__users__list__header {
  cursor: pointer;
  padding: 0.25rem 1rem;
  font-weight: normal;
  font-size: 0.9rem;
  user-select: none;
  transition: transform 0.25s;
}

.brutto__users__list__header:hover {
  color: var(--blue);
}

.brutto__users__list__header:active {
  transform: scale(0.98);
}

.bttn-primary.bttn-primary--disabled {
  opacity: 0.65;
  cursor: not-allowed;
  box-shadow: none !important;
}

.bttn.bttn-primary.bttn--loading:before {
  border: 3px solid #ffffff;
  border-left: 3px solid transparent;
  pointer-events: none;
}

.user-agreements__notefield {
  font-weight: normal;
  border-top: 1px solid #ddd;
  padding: 1rem 0 2rem 0;
  margin-top: 2rem;
}

.user-agreements__notefield__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 1rem 0;
}

.user-agreements__notefield__header label.d-label {
  margin-left: 0.5rem;
  line-height: 1;
}

.tw-icon {
  width: 16px;
}

.tw-icon .secondary {
  fill: #0D2B3E;
}

.tw-icon .primary {
  fill: #A5B3BB;
}

h4.text-explainer {
  display: flex;
  align-items: center;
  font-size: 11px;
  font-weight: normal;
  margin-top: 0.5rem;
}

h4.text-explainer svg {
  margin-right: 5px;
}

.brutto-warning {
  width: 350px;
  border-radius: 4px;
}

.brutto-warning__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ffffff;
  padding: 1rem;
  border-bottom: 1px solid #dddddd;
  border-radius: 4px 4px 0 0;
}

.brutto-warning__body {
  padding: 1rem;
}

.brutto-warning__footer {
  display: flex;
  justify-content: flex-end;
  padding: 1rem;
  border-radius: 0 0 4px 4px;
}

.brutto-warning__footer button {
  margin-left: 1rem;
}

.bttn.bttn-primary.bttn-primary--small {
  padding: 2px 1rem;
}

.tw-icon.tw-icon--red {
  color: #ef4746;
}

.d-tabs {
  display: flex;
}

.d-tabs__tab {
  border: 1px solid transparent;
  border-bottom: 0;
  padding: 0.5rem;
  border-radius: 4px 4px 0 0;
  margin-right: 0.5rem;
  margin-bottom: -1px;
  cursor: pointer;
}

.d-tabs__tab.d-tabs__tab--active {
  border-color: #dddddd;
  background: #edf0f5;
}

.d-tabs__content {
  border: 1px solid #dddddd;
  padding: 1rem;
  border-radius: 0 4px 4px 4px;
}

.norm-title {
  font-weight: bold;
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}

.norm-title__sub {
  font-weight: lighter;
  font-size: 11px;
}

.label-with-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem;
  border-radius: 4px;
  margin: 0 -0.5rem;
  cursor: pointer;
  transition: 0.15s ease;
}

.label-with-toggle label {
  cursor: pointer;
}

.label-with-toggle:hover {
  background: aliceblue;
}

.brutto__items__item__container {
  border: 1px solid #dddddd;
  padding: 0.5rem 1rem;
  margin: 0 -1rem 1rem -1rem;
  border-radius: 4px;
}

.brutto__items__item__container .brutto__items__item {
  margin-top: 0.5rem;
}

.brutto__items__item__container__notefield {
  margin: -1rem 0;
  font-weight: normal;
}

.brutto__items__item__container__notefield.brutto__items__item__container__notefield--alone {
  margin: 1rem 0;
}

.brutto--kindergarten .brutto__items__item__container__notefield {
  margin: 1rem 0;
}

.do-table tbody tr:hover .d-edit-btn {
  opacity: 1;
}

.d-edit-btn {
  opacity: 0;
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
}

.d-input-group__input > input[type="number"][disabled] {
  background: #eeeeee;
  cursor: not-allowed;
}

.employment-rate-calculator {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-right: 0.5rem;
}

.rest-calculation {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1rem;
  padding: 1rem 1rem 0;
  margin-bottom: -0.5rem;
}

.rest-calculation label.d-label {
  margin-bottom: 0;
}

.d-tabs__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.d-tabs__header__right > .label-with-toggle {
  display: flex;
  gap: 0.5rem;
}

.d-tabs__header__right--alone {
  border: 1px solid #dddddd;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  margin-right: -0.5rem;
  width: 100%;
}

.do-spinner__container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;
}

#holidays-settings {
  padding: 1.5rem 1rem 0.5rem;
  text-align: left;
}

#holidays-settings h3 {
  margin: 0 0 0.5rem;
  padding: 0;
}

#holidays-settings p {
  margin: 0 0 1rem;
  padding: 0;
  font-weight: normal;
  font-size: 12px;
  line-height: 1.4;
}

.holidays-settings__input {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.holidays-settings__input .d-input-group__input {
  display: flex;
  align-items: center;
}

.holidays-settings__input input[type="number"] {
  background: #fff;
  padding: 0.25rem 0.5rem;
  width: 100px;
}

.holidays-settings__input .label {
  margin-left: 0.5rem;
  font-size: 0.85rem;
}

.holidays-settings__buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
}

.holidays-settings__buttons__right {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}

.holidays-settings__list {
  margin: 0 0 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  background: #fff;
  font-weight: normal;
  font-size: 12px;
}

.holidays-settings__list__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 0.75rem;
  border-bottom: 1px solid #e2e8f0;
  background: #f6f9fc;
  font-weight: bold;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--grey);
}

.holidays-settings__list ul {
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: 320px;
  overflow-y: auto;
}

.holidays-settings__list ul li {
  display: flex;
  align-items: center;
  padding: 0.35rem 0.75rem;
  border-bottom: 1px solid #f1f5f9;
  gap: 0.5rem;
  line-height: 1.2;
  white-space: nowrap;
}

.holidays-settings__name {
  font-weight: bold;
  font-size: 12px;
}

.holidays-settings__name + .holidays-settings__date {
  color: var(--grey);
  font-size: 11px;
}

.holidays-settings__list ul li:last-child {
  border-bottom: 0;
}

.holidays-settings__list ul li.is-weekend {
  color: var(--grey);
  font-style: italic;
}

.holidays-settings__list ul li.is-weekend .holidays-settings__date {
  text-decoration: line-through;
}

.holidays-settings__date::first-letter {
  text-transform: uppercase;
}

.holidays-settings__number {
  display: inline-block;
  min-width: 16px;
  color: #ccc;
  font-size: 12px;
  flex-shrink: 0;
  border-right: 1px solid #e2e8f0;
}

.holidays-settings__number--empty {
  color: #cbd5e0;
  font-weight: normal;
}

.holidays-settings__tag {
  margin-left: auto;
  font-size: 10px;
  background: #edf0f5;
  color: var(--grey);
  padding: 1px 6px;
  border-radius: 999px;
  font-style: normal;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.holidays-settings__list__sum {
  padding: 0.5rem 0.75rem;
  border-top: 1px solid #e2e8f0;
  text-align: right;
  background: #f6f9fc;
}

</style>



// WEBPACK FOOTER //
// AssignHoursNorm.vue?51eac17e